import { useTranslation } from 'react-i18next';
import { NAMESPACE } from 'locale';
import { Modal } from '@lmc/ui-kit';
import { Text } from '@lmc/ui-kit/src/general';
import { generalConstants } from 'locale/general';
import styled from 'styled-components';

type UpdatePromptModalProps = {
  onRefresh: () => void;
  onRemindLater: () => void;
  isOpen?: boolean;
};

const UpdatePromptModal = ({
  onRefresh,
  onRemindLater,
  isOpen = false,
}: UpdatePromptModalProps) => {
  const { t } = useTranslation(NAMESPACE.GENERAL);

  return (
        <Modal
            localisation={{
                confirmText: t(generalConstants.REMIND_ME_LATER),
                title: t(generalConstants.UPDATE_PROMPT_TITLE),
                cancelText: t(generalConstants.ClickHere),
            }}
            noPadding
            onConfirm={onRemindLater}
            onCancel={onRefresh}
            isModalVisible={isOpen}
        >
            <ModalContentWrapper>
                <Text level={1} weight="bold">
                    {t(generalConstants.UPDATE_PROMPT_MESSAGE)}
                </Text>
            </ModalContentWrapper>
        </Modal>
  );
};

const ModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export default UpdatePromptModal;